import { render } from "./MouvementDuStockPage.vue?vue&type=template&id=71971ca7&ts=true"
import script from "./MouvementDuStockPage.vue?vue&type=script&lang=ts"
export * from "./MouvementDuStockPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__